import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Button } from '@rocketlane/ui';
import styled from 'styled-components';

export const SidebarMenuSection = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;
  font-size: 14px;
  color: var(--gray-100);
  font-weight: 590;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  height: 32px;
  margin-bottom: 4px;
`;

export const EllipsisAction = styled.div`
  opacity: 0;
  transition: opacity 0.15s;
`;

export const SectionSubItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px 2px 32px;
  font-size: 14px;
  color: var(--gray-100);
  border-radius: 4px;
  background: ${({ selected }) =>
    selected ? 'var(--gray-10)' : 'transparent'};
  cursor: pointer;
  transition: background 0.15s;
  height: 32px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    background: #f4f4f4;
  }
  justify-content: space-between;
  min-width: 0;

  &:hover ${EllipsisAction} {
    opacity: 1;
  }
`;

export const SectionSubItemLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  flex: 1;
  min-width: 0;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`;

export const FlexSpacer = styled.span`
  flex: 1;
`;

export const EllipsisIcon = styled(StyledIcon)`
  cursor: pointer;
`;

export const DrawerFooterButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  justify-content: space-between;
`;

export const DrawerFooterButton = styled(Button)`
  flex: 1;
  height: 40px;
`;

export const DrawerHeaderTitle = styled.div`
  ${({ theme }: any) => theme?.typography?.heading03 || ''};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
